module.exports = __webpack_public_path__ + "img/28.f10baf30.png";